import { useEffect, useState } from 'react';
import { Button } from './Button';

const COOKIE_PREF_KEY = 'foodvalve_admin_cookie_consent';

type CookiePreference = {
  accepted: boolean;
  analytics: boolean;
  saved_at: string;
};

function loadPreference(): CookiePreference | null {
  try {
    const raw = window.localStorage.getItem(COOKIE_PREF_KEY);
    return raw ? (JSON.parse(raw) as CookiePreference) : null;
  } catch {
    return null;
  }
}

function savePreference(analytics: boolean): void {
  const preference: CookiePreference = {
    accepted: true,
    analytics,
    saved_at: new Date().toISOString(),
  };
  window.localStorage.setItem(COOKIE_PREF_KEY, JSON.stringify(preference));
}

export function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(loadPreference()?.accepted !== true);
  }, []);

  if (!visible) return null;

  const accept = (analytics: boolean) => {
    savePreference(analytics);
    setVisible(false);
  };

  return (
    <div className="fixed inset-x-3 bottom-3 z-50 mx-auto max-w-4xl rounded-lg border border-fv-border bg-white p-4 shadow-xl md:bottom-5">
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div>
          <p className="text-sm font-semibold text-fv-text">Cookie preferences</p>
          <p className="mt-1 text-sm text-fv-muted">
            Food Valve Admin uses essential cookies for secure sign-in and CSRF protection.
            Optional analytics cookies help improve the admin experience.
          </p>
        </div>
        <div className="flex shrink-0 flex-wrap gap-2">
          <Button variant="secondary" onClick={() => accept(false)}>
            Essential only
          </Button>
          <Button onClick={() => accept(true)}>Accept cookies</Button>
        </div>
      </div>
    </div>
  );
}
